/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('Service worker is ready to go.')
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      //window.location.reload();
      console.log('Content has been cached for offline use.')
    },
    updatefound (sW) {
      console.log('New content is downloading.', sW)
    },
    updated (r) {
      console.log('New content is available; please refresh.', r)
      //window.location.reload();
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
